<template>
    <div class="content">
        <div class="button">
            <van-field
                    v-model="titleTimeStart"
                    placeholder="选择开始时间" readonly="readonly"
                    @click="dateShowStart = true"
            />
            <van-field
                    v-model="titleTime"
                    placeholder="选择结束时间" readonly="readonly"
                    @click="dateShow = true"
            />
            （开始结束时间必填，最多只返回100条）
            <div class="table-box" v-if="jdCpaDetail.page&&jdCpaDetail.page.length>0">
                <table width="100%">
                    <tr v-for="(row,index) in jdCpaDetail.page" :key="row.id">
                        <td style="text-align:left;word-break:break-all;">
                            <div v-if="2==query.source">
                                <van-cell title="订单时间" :value="row.orderDate"/>
                                <van-cell title="京东账户" :value="row.jdAccount"/>
                                <van-cell title="是否开通白条" :value="row.ext1 ? '是' : '否'"/>
                                <van-cell title="白条开通时间" :value="row.ext2"/>
                                <van-cell title="首单交易时间" :value="row.ext3"/>
                                <van-cell title="是否购券" :value="row.ext4"/>
                                <van-cell title="是否领取礼金" :value="'success' == row.ext5 ? '是' : '否'"/>
                                <van-cell title="用户参与与白条首单时间差" :value="row.ext6"/>
                            </div>
                            <div v-else>
                                <van-cell title="下单时间" :value="row.orderDate"/>
                                <van-cell title="订单号" :value="row.orderNum"/>
                                <van-cell title="付款金额" :value="row.price"/>
                                <van-cell title="是否为首购" :value="row.firstBuy == '有效' ? '有效' : '待确认'"/>
                                <van-cell title="商品名称" :value="row.productName"/>
                                <!--<van-cell title="是否有效下载" :value="row.validDown"/>-->
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <van-popup v-model="dateShowStart" position="bottom">
                <van-datetime-picker v-model="currentDateStart" type="datetime" @cancel="handleCancel"
                                     @confirm="handleStartDateConfirm"/>
            </van-popup>
            <van-popup v-model="dateShow" position="bottom">
                <van-datetime-picker v-model="currentDate" type="datetime" @cancel="handleCancel"
                                     @confirm="handleEndDateConfirm"/>
            </van-popup>
        </div>
    </div>

</template>

<script>
    import countAPI from '@/api/count'

    export default {
        data() {
            return {
                query: {
                    linkId: this.$route.query.linkId,
                    source: this.$route.query.source,
                },
                dateShow: false,
                currentDate: new Date(),
                titleTime: "",
                dateShowStart: false,
                titleTimeStart: "",
                currentDateStart: new Date(),
                jdCpaDetail: {}
            }
        },
        methods: {
            handleCancel() {
                this.dateShow = false;
                this.dateShowStart = false;
            },
            //开始时间
            handleStartDateConfirm() {
                this.dateShowStart = false;
                this.titleTimeStart = this.timeFormat(this.currentDateStart);
                this.queryjdCpaDetail();
            },
            //结束时间
            handleEndDateConfirm() {
                this.dateShow = false;
                this.titleTime = this.timeFormat(this.currentDate);
                this.queryjdCpaDetail();
            },
            timeFormat(datetime) { // 时间格式化 2019-09-08
                var year = datetime.getFullYear();
                var month = (datetime.getMonth() + 1) < 10 ? "0" + (datetime.getMonth() + 1) : (datetime.getMonth() + 1);
                var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
                var hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
                var minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
                var second = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
                return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
            },
            queryjdCpaDetail() {
                //if(!isNaN(this.month4selected)){
                //  this.queryLog.startSettleDate=this.$myUtil.startDateDef(this.month4selected*30)
                //}

                if (this.titleTime && this.titleTimeStart) {
                    this.$toast.loading({forbidClick: true});

                    let queryObj = {};
                    queryObj.ext1 = this.titleTime;
                    queryObj.ext2 = this.query.linkId;
                    queryObj.ext3 = this.titleTimeStart;
                    queryObj.ext4 = this.query.source;

                    countAPI.jdCpaDetail(queryObj).then((result) => {
                        this.jdCpaDetail = result.data;
                        this.$toast.clear()
                    })
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

    .content {
        padding-top: 2rem;
    }

    .button {
        background-color: #fff;
        margin: 2rem 5%;
        height: 3rem;
        border-radius: 2rem;
        text-align: center;
        line-height: 3rem;
    }

</style>
